import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionComponent } from '@shared/ui-components/accordion/accordion.component';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { ProfileInfoComponent } from '@core/components/header/profile-info/profile-info.component';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';
import { InitialsPipe } from '@shared/pipes/initial/initials.pipe';
import { authSelectors } from '@store/selectors/auth.selectors';
import { authActions } from '@store/actions/auth.actions';
import { HelpComponent } from '@core/components/header/help/help.component';
import { AuthConfigIds } from 'src/app/auth/auth.config';

@Component({
  selector: 'ac-side-nav-info-data',
  standalone: true,
  imports: [IconComponent, AccordionComponent, TranslateModule, ProfileInfoComponent, InitialsPipe, HelpComponent],
  templateUrl: './side-nav-info-data.component.html',
  styleUrls: ['./side-nav-info-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavInfoDataComponent {
  protected readonly _userSig = this._store.selectSignal(userSelectors.authUser);
  protected readonly _currentIdpSig = this._store.selectSignal(authSelectors.idp);
  constructor(private _store: Store<StoreState>) {}

  protected _logout(authConfigId: AuthConfigIds): void {
    this._store.dispatch(authActions.attemptLogout({ idp: authConfigId }));
  }
}
